import { render, staticRenderFns } from "./outpatientService.vue?vue&type=template&id=b2a9e7da&scoped=true"
import script from "./outpatientService.vue?vue&type=script&lang=js"
export * from "./outpatientService.vue?vue&type=script&lang=js"
import style0 from "./outpatientService.vue?vue&type=style&index=0&id=b2a9e7da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a9e7da",
  null
  
)

export default component.exports